import { Component, Input, OnInit } from '@angular/core';
import { TC } from '@tc-core/util/constants';
import { Resource } from '../../../models/resource/resource';

@Component({
    selector: 'tc-guide-specific-details-card',
    templateUrl: './guide-specific-details-card.component.html'
})
export class GuideSpecificDetailsCardComponent implements OnInit {

    @Input() resource: Resource;

    EMPTY_CHAR = TC.FORMAT.EMPTY_CHAR;

    constructor() { }

    ngOnInit() {
    }

}
